import { __rest } from '../../common/temp/node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { clsx } from '../../../../../common/temp/node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js';
import { forwardRef } from 'react';
import { withStyleProps } from '../../_common/hocs/styleProps/withStyleProps.js';
import '../../_common/hocs/styleProps/styleProps.config.js';
import '../../tokens/tokens-base/properties/build/js/index.js';
import '../../common/temp/node_modules/.pnpm/deepmerge@4.2.2/node_modules/deepmerge/dist/cjs.js';
import { css } from '../../_common/stitches/stitches.config.js';
import { StyledFlex } from './Flex.styles.js';
import { getFlexStitchesVariants } from './Flex.utils.js';
const FlexComponent = forwardRef((props, ref) => {
  const {
      alignItems = 'stretch',
      flexDirection = 'row',
      flexWrap = 'wrap',
      justifyContent = 'flex-start',
      centered = false,
      as = 'div',
      gap = 'none',
      children,
      className
    } = props,
    flexProps = __rest(props, ["alignItems", "flexDirection", "flexWrap", "justifyContent", "centered", "as", "gap", "children", "className"]);
  const variants = getFlexStitchesVariants({
    centered,
    as,
    gap
  });
  const flexClass = css({
    alignItems,
    flexDirection,
    flexWrap,
    justifyContent
  })().className;
  return jsx(StyledFlex, Object.assign({}, flexProps, variants, {
    className: clsx('Copan_Flex', flexClass, className),
    ref: ref
  }, {
    children: children
  }), void 0);
});
FlexComponent.displayName = 'ReactBase_Flex';
const Flex = withStyleProps(FlexComponent);
export { Flex };